/**
 * Stellt Methoden für die Behandlung von Links bereit, die von Hypertext-Elementen verwendet werden.
 *
 * @class service_v3sHyperTextService
 * @memberOf v3sWbtPlayerApp:page:elements
 */
angular.module('v3sWbtPlayerApp').factory('v3sHypertextService', ["$window", "v3sNavigationService", "v3sPopupService", "v3sAnimationService", "v3sLinkService", function ($window, v3sNavigationService, v3sPopupService, v3sAnimationService, v3sLinkService) {
    /**
    * Öffnet URL, Seite oder Popup.
    *
    * @memberOf v3sWbtPlayerApp:page:elements.service_v3sLinkService
    * @param {object} element - aktivierendes Element
    * @param {object} options - Optionen wie itemId, filePath, popupId, url
    */
    function createLinkOnClick(element, options, scope, callbackOnCompleted, callbackOnLocked) {
        var item = null;
        var url = "";

        if (!callbackOnCompleted) {
            callbackOnCompleted = function () { };
        }

        if (!callbackOnLocked) {
            callbackOnLocked = function () { };
        }

        if (options.itemId) {
            item = v3sLinkService.findItem(options.itemId);

        } else if (options.filePath) {
            item = v3sLinkService.findItem(options.filePath);

            if (!item) {
                url = v3sLinkService.convertMediaPath(options.filePath);
            }

        } else if (options.url) {
            url = options.url;

        } else if (options.popupId) {
            element.bind("click", function (evt) {
                v3sPopupService.show(options.popupId, element);
                callbackOnCompleted();
            });

        } else if (options.entry) {
            element.bind("click", function (evt) {
                evt.preventDefault();
                var action = {
                    entry: options.entry,
                    command: "showLex"
                };

                var tween = v3sAnimationService.createTween(action, true);
            });
        }

        if (item) {
            element.bind("click", function () {
                v3sNavigationService.goTo(v3sNavigationService.getPageState(item));
            });
        } else if (url) {
            element.bind("click", function (evt) {
                evt.preventDefault();
                $window.open(url);
                callbackOnCompleted();
            });
        }

        if (!!scope && !!item) {
            callbackOnCompleted(item.getStatus(), item.getExerciseStatus());
            
            if (item.isLocked()) {
                callbackOnLocked(true);
            }

            item.subscribePageChanged(scope, function () {
                callbackOnCompleted(item.getStatus(), item.getExerciseStatus());
                callbackOnLocked(item.isLocked());
            });
        }
    }

    /**
    * Gibt den Link-Typ zurück: URL, Seite, Lexikon, Popup (je nach Typ oder multi).
    *
    * @memberOf v3sWbtPlayerApp:page:elements.service_v3sLinkService
    * @param {object} options - Optionen wie itemId, filePath, popupId, url
    */
    function getLinkType(options) {
        // Seite
        if (options.itemId) {
            return "internal";
        }

        // Datei
        if (options.filePath) {
            return "document"
        }

        // Externer Link
        if (options.url) {
            return "link";

        }

        // Popup
        if (options.popupId) {
            var type = v3sPopupService.getType(options.popupId);

            if (!type) {
                return "multi";
            }

            return type;
        }

        // Lexikon
        if (options.entry) {
            return "paragraph";
        }

        // Standard
        return "link";
    }

    return {
        createLinkOnClick: createLinkOnClick,
        getLinkType: getLinkType
    }
}]);